<template>

    <FloatingPanel :title="title" :saveable="false">

        <div class="canvas::editor-website-editors-loop-LoopPanel">

        </div>

        <template v-slot:actions>

            <!-- Add padding since usually we only have a single item, if more is needed; I suggest changing this in your custom panel -->
            <div :class="{
                'p-4': !$slots['actionsExtra'],
            }">
                <button
                    class="btn btn-blue"
                    @click="addItem">
                    <i class="mr-1 fa fa-plus"></i> Item toevoegen
                </button>
            </div>

        </template>

    </FloatingPanel>

</template>

<script>

import FloatingPanel from "../panels/FloatingPanel";
import AbstractPanel from "../AbstractPanel";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
    },

    props: {
        title: {
            type: String,
            default() {
                // Equals this.loopEditorComponent which cannot be computed yet since we are setting up props right now.
                return (this.$pageComponent().selection.currentSelection.editableData.label || 'Herhaling') + ' bewerken';
            },
        },
    },

    methods: {

        addItem() {
            // Add empty to loop items.
            this.loopItems.push({});
        },

    },

    computed: {

        loopItems() {
            return this.loopEditorComponent.loopItems;
        },

        loopEditorComponent() {
            return this.editorComponent;
        },

    }

}

</script>

<style lang="scss" scoped>

.canvas\:\:editor-website-editors-loop-LoopPanel {
}

</style>
